export function scrollElementIntoViewUntilItsTopPositionIsStable(
  element: HTMLElement,
  waitTime = 1000,
) {
  let top = 0;
  let timer: NodeJS.Timeout | null = null;
  let interval: NodeJS.Timeout | null = null;

  interval = setInterval(() => {
    const newTop = getElementTopOffsetFromPage(element);
    if (newTop === top) return;

    element.scrollIntoView();
    top = newTop;
    if (timer) clearTimeout(timer);
    timer = setTimeout(() => clearInterval(interval!), waitTime);
  }, 25);
}

function getElementTopOffsetFromPage(el: HTMLElement | null): number {
  if (!el) return 0;

  const rect = el.getBoundingClientRect();

  const scrollTop =
    window.pageYOffset || document.documentElement.scrollTop || document.body.scrollTop || 0;

  return Math.round(rect.top + scrollTop);
}
